import type { PlanungRow } from "@/lib/montageplanung";

/** Zerlegt gespeichertes Auftragslabel (Nummer · Kunde · Ort · …). */
export function splitOrderLinkLabel(
  orderId: number,
  label: string | null | undefined,
): { number: string; details: string | null } {
  const trimmed = label?.trim();
  if (!trimmed) {
    return { number: `#${orderId}`, details: null };
  }
  const parts = trimmed.split(" · ").map((p) => p.trim()).filter(Boolean);
  if (parts.length >= 2) {
    return {
      number: parts[0]!,
      details: parts.slice(1).join(" · ") || null,
    };
  }
  return { number: trimmed, details: null };
}

export function rowLabelFull(row: PlanungRow): string {
  if (row.kind === "separator") {
    return (row.label?.trim() || "Trennlinie").trim();
  }
  return (row.label?.trim() || row.employee_login || "—").trim();
}

/** Kürzel für schmale Label-Spalte (Initialen / Akronym). */
export function rowLabelAbbrev(row: PlanungRow): string {
  if (row.kind === "separator") {
    return "—";
  }
  const full = rowLabelFull(row);

  if (row.kind === "resource") {
    const acronym = full.replace(/[^A-ZÄÖÜa-zäöü]/g, "");
    const upper = acronym.replace(/[a-zäöü]/g, (c) => c.toUpperCase());
    if (upper.length >= 2) return upper.slice(0, 4);
    return full.slice(0, 3).toUpperCase();
  }

  const parts = full.split(/[\s._-]+/).filter(Boolean);
  if (parts.length >= 2) {
    const first = parts[0]![0] ?? "";
    const last = parts[parts.length - 1]![0] ?? "";
    return `${first}${last}`.toUpperCase();
  }
  if (parts.length === 1 && parts[0]!.length >= 2) {
    return parts[0]!.slice(0, 2).toUpperCase();
  }
  return full.slice(0, 2).toUpperCase();
}

/** Anzeigetext im Balken – bei wenig Platz nur Kürzel (schmale Ein-Tages-Balken). */
export function assignmentBarLabel(title: string, span: number, barWidth: number): string {
  const trimmed = title.trim();
  if (!trimmed) return "—";

  const useAbbrev = span === 1 && barWidth < 44;
  if (!useAbbrev) return trimmed;

  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    return words
      .map((w) => w[0])
      .join("")
      .slice(0, 4)
      .toUpperCase();
  }
  return trimmed.length <= 4 ? trimmed : trimmed.slice(0, 3);
}
